module.exports = __webpack_public_path__ + "img/mobilenewsLogo10.61f29b22.png";